<template>
  <div style="margin-left:10%;">
    <!-- <div class="banner page-head flex-box">
      <div class="w-100">
        <div class="container">
          <div class="banner-caption">
            <h3>Web Integration</h3>
          </div>
        </div>
      </div>
    </div> -->
    <div class="row align-items-center justify-content-between">
      <!-- <div class="col-md-3" style="margin-top: 2%;margin-bottom:auto;">
        <a class="list-group-item list-group-item-action" href="#Intro">Introduction</a>
      </div> -->
      <div class="col-md-12" style="margin-top: 2%;">
        <div id="Intro" style="margin-top:0.5%">
          <h2 class="documentation-header">Introduction</h2>
          <p style="margin-top:30px">
            Welcome to Web Chatbot API
            <br />The API provides a flexible set of methods that can be used in your Web.
            <br />To invoke one of the below methods please be sure to call a method after embedding code on the page.
          </p>
        </div>
        <div class="row" style="margin-top:5px">
          <div class="col-md-12" id="step1">
            <p>1. Include these lines in the main project HTML File</p>
            <pre style="margin-left: auto;">
        &lt;link href="https://resource.cense.ai/css/app.css" rel="stylesheet"&gt;
        &lt;script src="https://resource.cense.ai/js/app.js"&gt;&lt;/script&gt;
        &lt;bot-chat/&gt;
            </pre>
          </div>
        </div>
        <!-- username: 'YOUR_USERNAME', //This can be captured from the session, for e.g. -->
        <div class="row" style="margin-top:5px">
          <div class="col-md-12" id="step1">
            <p>2. Call the function GenerateWidget in the given format</p>
            <pre style="margin-left: auto;">
        GenerateWidget({
          source: 'YOUR_SOURCE',     //Values would be "Web" for browser, "Mobile" for iOS/Android SDK
          license_key: 'YOUR_LICENSE_KEY'
        })
            </pre>
          </div>
        </div>
        <br />
        <br />
        <br />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    function offsetAnchor() {
      if (location.hash.length !== 0) {
        window.scrollTo(window.scrollX, window.scrollY - 100);
      }
    }
    window.addEventListener("hashchange", offsetAnchor);
    window.setTimeout(offsetAnchor, 1);
  }
};
</script>

<style scoped>
h6 {
  font: normal normal normal 1rem/2.5rem Poppins;
}
p {
  font: normal normal normal 1rem/1.45rem Poppins;
}
.list-group-item {
  background-color: unset;
  border-width: 0px 0px 1px 0px;
}
pre {
  color: #ff1493;
}
@media (max-width: 768px) {
  .col-md-3,
  .col-md-9 {
    padding-left: 4%;
    padding-right: 4%;
  }
}
@media (min-width: 768px) {
  .col-md-3 {
    padding-left: 2%;
  }
}
</style>